export default __webpack_public_path__ + "static/media/cp_geo_np.663d5e17.svg";